const statementTabs = {
	tabs : $('.js-statementTabs__tab'),
	select(id) {
		this.tabs.removeClass('current');
		$(`.js-statementTabs__tab[data-id="${id}"]`).addClass('current');
	}
}
$(document).on('click', '.js-statementTabs__button', function() {
	$('.js-statementTabs__button').removeClass('current');
	$(this).addClass('current');
	statementTabs.select($(this).data('tab'));
});

$(document).on('click touchstart', '.js-statementDesc__icon', function() {
	$(this).toggleClass('current');
	if ($(this).hasClass('current')) {
		$('.js-statementDesc').find('.statementDesc__text').fadeIn(function() { $(this).stop(); });
	} else {
		$('.js-statementDesc').find('.statementDesc__text').fadeOut(function() { $(this).stop(); });
	}
})